import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@ncoder/ui";

import { RequestToolForm } from "@/components/molecules/modernise-with-ai/RequestToolForm";

interface RequestToolModalProps {
  open: boolean;
  onClose: () => void;
  form: {
    toolName: string;
    description: string;
    importance: string;
    useCase: string;
  };
  onChange: (key: string, value: string) => void;
  onSubmit: () => void;
}

export const RequestToolModal: React.FC<RequestToolModalProps> = ({
  open,
  onClose,
  form,
  onChange,
  onSubmit,
}) => (
  <Dialog open={open} onOpenChange={onClose}>
    <DialogContent className="sm:max-w-[500px]">
      <DialogHeader>
        <DialogTitle>Request New Modernization Tool</DialogTitle>
        <DialogDescription>
          Tell us about the custom modernization tool you need for your org.
        </DialogDescription>
      </DialogHeader>

      <RequestToolForm form={form} onChange={onChange} />

      <div className="flex justify-end gap-2 mt-4">
        <Button variant="outline" onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={onSubmit}>Submit Request</Button>
      </div>
    </DialogContent>
  </Dialog>
);
